module.exports = __webpack_public_path__ + "img/the-good-02.9dfbda2b.jpg";